import React, {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import {getLogoSize} from '../../constants/logoSizes';
import {pushInteractionTagManager} from '../../services/tagManager';
import {
  deleteAcceptWarnings,
  setAcceptWarnings
} from '../../services/warnings/warnings';
import LazyImage from '../PartnerMachines/LazyImage';
import {PartnerMachinesGrid} from '../PartnerMachines/PartnerMachinesGrid';

const psrGetnet = '/psrs/psr-getnet-v2.png';
import './StartAccreditation.style.scss';

export const StartAccreditation = () => {
  const navigate = useNavigate();

  const eventTooltip = {
    elementType: 'select:tooltip:click',
    screenName: 'credenciamento:modal'
  };

  const acceptWarnings = () => {
    pushInteractionTagManager({
      elementType: 'box:button:click',
      elementContent: 'none:iniciar-credenciamento:none',
      screenName: 'credenciamento:modal'
    });
    setAcceptWarnings('yes');
    navigate('/chat');
  };

  useEffect(() => {
    deleteAcceptWarnings();
  }, []);

  return (
    <section
      className="start-accreditation"
      data-testid="modal-start-accreditation"
    >
      <header className="start-accreditation__box-title">
        <h2 className="start-accreditation__title">
          Habilite suas maquininhas
        </h2>
      </header>
      <article className="start-accreditation__content">
        <p className="start-accreditation__text">
          Você tem alguma dessas maquininhas para pagamentos presenciais ou
          online?{' '}
        </p>
        <p className="start-accreditation__text">
          Se sim, <strong>separe os documentos necessários</strong> e{' '}
          <strong>clique no botão Iniciar Credenciamento!</strong>!
        </p>
        <div className="start-accreditation__box-psrs-allowed-fixed">
          <PartnerMachinesGrid
            compact
            excludeIds={['getnet']}
            centerLastRow
          />
        </div>
        <div className="start-accreditation__box-button">
          <button
            className="start-accreditation__button"
            data-testid="start-accreditation"
            onClick={() => {
              acceptWarnings();
            }}
          >
            iniciar credenciamento
          </button>
        </div>
        <p className="start-accreditation__text">
          Mas se você tem alguma das maquininhas abaixo, pedimos que{' '}
          <strong>
            {' '}
            entre em contato com a central de atendimento da maquininha
          </strong>{' '}
          para habilitar nossos produtos =)
        </p>
        <div className="start-accreditation__box-psrs-not-allowed">
          <div className="start-accreditation__psr-not-allowed tooltip-modal">
            <span>
              <a
                data-testid="go-get"
                href="https://site.getnet.com.br"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  pushInteractionTagManager({
                    elementContent: 'none:getnet:maquininhas-parceiras-under',
                    ...eventTooltip
                  })
                }
              >
                ACESSE O SITE
              </a>
            </span>
            <LazyImage
              src={psrGetnet}
              alt="Logo Getnet"
              logoSize={getLogoSize('getnet')}
            />
          </div>
        </div>
      </article>
    </section>
  );
};
